export default "__VITE_ASSET__cc44fb3f__"